class SpecialOprations extends HTMLElement {
    constructor() { super() }

    connectedCallback() {}

    attributeChangedCallback(attName, oldValue, newValue) {
        switch (attName) {
        case 'css': {
            const styleSheet = document.createElement('style')
            styleSheet.innerText = newValue
            document.head.appendChild(styleSheet)
            break
        }
        }
    }

    static get observedAttributes() { return ['css'] }
}

customElements.define('special-oprations', SpecialOprations)